import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { downloadFile, errMsg } from "@/lib/api";
import { Chip } from "@/components/kit";

const TYPES = [["checkins", "Check-ins"], ["journal", "Journal"]];

export const ExportDataCard = () => {
  const [types, setTypes] = useState(["checkins", "journal"]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [busy, setBusy] = useState("");

  const toggle = (t) => setTypes((x) => (x.includes(t) ? x.filter((y) => y !== t) : [...x, t]));
  const qs = (fmt, list) => new URLSearchParams({ fmt, types: list.join(","), ...(start && { start }), ...(end && { end }) }).toString();

  const go = async (fmt) => {
    if (!types.length) return toast.error("Pick check-ins, journal or both");
    setBusy(fmt);
    try {
      if (fmt === "pdf") await downloadFile(`/export/data?${qs("pdf", types)}`, "mindfulme-export.pdf");
      else for (const t of types) await downloadFile(`/export/data?${qs("csv", [t])}`, `mindfulme-${t}.csv`);
      toast.success("Download started");
    } catch (e) {
      toast.error(errMsg(e, "Export failed"));
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="p-4" data-testid="export-data-card">
      <div className="font-medium flex items-center gap-2"><Download size={18} />Export my data</div>
      <p className="text-xs text-mm-muted mt-1">Keep a private copy as a readable PDF or a CSV spreadsheet.</p>
      <div className="flex gap-2 mt-3">
        {TYPES.map(([id, label]) => <Chip key={id} on={types.includes(id)} onClick={() => toggle(id)} testId={`export-type-${id}`}>{label}</Chip>)}
      </div>
      <div className="grid grid-cols-2 gap-2 mt-3">
        <label className="text-xs text-mm-muted">From<input type="date" className="mm-input mt-1" value={start} max={end || undefined} onChange={(e) => setStart(e.target.value)} data-testid="export-start" /></label>
        <label className="text-xs text-mm-muted">To<input type="date" className="mm-input mt-1" value={end} min={start || undefined} onChange={(e) => setEnd(e.target.value)} data-testid="export-end" /></label>
      </div>
      <div className="flex gap-2 mt-3">
        <button className="mm-btn" onClick={() => go("pdf")} disabled={!!busy} data-testid="export-pdf-button">{busy === "pdf" ? <Loader2 size={16} className="animate-spin" /> : "Download PDF"}</button>
        <button className="mm-btn-ghost" onClick={() => go("csv")} disabled={!!busy} data-testid="export-csv-button">{busy === "csv" ? <Loader2 size={16} className="animate-spin" /> : "Download CSV"}</button>
      </div>
    </div>
  );
};
